// import Login from '../views/Login.vue'
import NotFound from '../views/404.vue'
import Home from '../views/Home.vue'
import Main from '../views/Main.vue'

// 会员管理
import MemberList from '../views/MemberManagement/MemberList.vue'
import BasicInfoList from '../views/MemberManagement/BasicInfoList.vue'

import Consumption from '../views/MemberManagement/Consumption.vue'
import Business from '../views/MemberManagement/Business.vue'
import Evaluate from '../views/MemberManagement/Evaluate.vue'



// 基础设置
import FrequencyCard from '../views/BasicSetting/FrequencyCard.vue'
import MonthCard from '../views/BasicSetting/MonthCard.vue'
import RechargeableCard from '../views/BasicSetting/RechargeableCard.vue'
import TrainingCard from '../views/BasicSetting/TrainingCard.vue'
import YearCard from '../views/BasicSetting/YearCard.vue'
import RechargeableCardConsumption from '../views/BasicSetting/RechargeableCardConsumption.vue'
import OwnerCard from '../views/BasicSetting/OwnerCard.vue'
import Machine from '../views/BasicSetting/Machine.vue'
import Letter from '../views/BasicSetting/Letter.vue'
import LetterSign from '../views/BasicSetting/LetterSign.vue'




// import test from '../views/BasicSetting/test.vue'



// 微信相关
// import OAuth from '../views/WeiXin/OAuth.vue'
// import WeiXinMain from '../views/WeiXin/WeiXinMain.vue'
// import WeiXinSett from '../views/BasicSetting/WeiXinSett.vue'

// import user from './views/MemberManagement/user.vue'
import ShopInfo from '../views/ShopManagement/ShopInfo.vue'
import ShopUser from '../views/ShopManagement/ShopUser.vue'
import ShopPay from '../views/ShopManagement/ShopPay.vue'
import ShopPayView from '../views/ShopManagement/ShopPayView.vue'
import EvaluateShop from '../views/MemberManagement/EvaluateShop.vue'


// import Page6 from './views/nav3/Page6.vue'
// import echarts from './views/charts/echarts.vue'
// import ShopList from './views/ShopManagement/ShopList.vue'
import Authority from '../views/Authority.vue'

import TabsView  from '../views/MemberManagement/TabsView.vue'
import Coach  from '../views/BasicSetting/Coach.vue'
import ChangeCoachLog  from '../views/Log/ChangeCoachLog.vue'
import ResetLog  from '../views/Log/ResetLog.vue'
import PostPoneLog  from '../views/Log/PostPoneLog.vue'


import echarts from '../views/charts/echarts.vue'
import SummaryTabsView  from '../views/ShopManagement/SummaryTabsView.vue'
import OnlineSet  from '../views/WeiXin/OnlineSet.vue'
import Ticket  from '../views/TicketManagement/Ticket.vue'
import TicketOrder  from '../views/TicketManagement/TicketOrder.vue'
import CoachlogReport  from '../views/Log/CoachlogReport.vue'
import CoachlogReportDay  from '../views/Log/CoachlogReportDay.vue'
import CoachlogReportTavsView from '../views/Log/CoachlogReportTavsView.vue'
// import CoachlogTabsView from '../views/ShopManagement/TabsView.vue'



import TrainingReport  from '../views/Log/TrainingReport.vue'
import Authorization  from '../views/MemberManagement/Authorization.vue'
import Over  from '../views/MemberManagement/Over.vue'
import Census from '../views/OneCardSystem/Census.vue'



import Team  from '../views/Competition/Team.vue'
import TeamLeader  from '../views/Competition/TeamLeader.vue'
import TeamStaff  from '../views/Competition/TeamStaff.vue'
import TeamPlayer  from '../views/Competition/TeamPlayer.vue'

import CompetitionEntry  from '../views/Competition/CompetitionEntry.vue'
import EntryView  from '../views/Competition/Entry.vue'
import HandCards  from '../views/MemberManagement/HandCards.vue'
import RechargeRecord  from '../views/MemberManagement/RechargeRecord.vue'
import MotionGroupData from '../views/SwimmingData/MotionGroupData.vue'


import SurplusFrequencyCard from '../views/DetachView/Shop/Surplus/FrequencyCard.vue'
import SurplusMonthCard from '../views/DetachView/Shop/Surplus/MonthCard.vue'
import SurplusOwnerCard from '../views/DetachView/Shop/Surplus/OwnerCard.vue'
import SurplusRechargeableCard from '../views/DetachView/Shop/Surplus/RechargeableCard.vue'
import SurplusTrainingCard from '../views/DetachView/Shop/Surplus/TrainingCard.vue'
import SurplusYearCard from '../views/DetachView/Shop/Surplus/YearCard.vue'

import SwimmingData from '../views/SwimmingData/Shop/SwimmingData.vue'
import WaterQualityData from '../views/WaterQuality/Shop/WaterQualityData.vue'
import Water from '../views/WaterQuality/Shop/Water.vue'
import WattMeter from '../views/WaterQuality/Shop/WattMeter.vue'


let shuidianlist = 
     [
        {
            path:'',
            component: Home,
            hidden: true,
           
          },
        {
            
            path: '/',
            component: (resolve) => require(['../views/Home.vue'], resolve),
            name: '场馆数据',
            iconCls: 'fa fa-bar-chart',
            children: [
                { path: '/Water', component: Water, name: '水表数据' },  
                { path: '/WattMeter', component: WattMeter, name: '电表数据' },                
            ]
        },                              
        {
            path: '/404',
            component: NotFound,
            name: '',
            hidden: true
        },
        {
            path: '*',
            hidden: true,
            redirect: { path: '/404' }
        }      
    ];

export default shuidianlist;


// WEBPACK FOOTER //
// ./src/userroutes/shuidian.js